import styled from "styled-components";
import { Flex, Table } from "@ebscois/react-component-library";

export const TableRow = styled(Table.Row)`
  display: flex;
`;

export const TableCell = styled(Table.Cell)`
  display: flex;
  flex: 1;
  vertical-align: middle;
  ${({ theme }) => `
    font-size: ${theme.font.size.lg};
    font-family: ${theme.font.family.base};
    line-height: ${theme.space.lg};
    color: ${theme.colors.gray700};
    padding: 0.75rem ${theme.space.xs} !important;
    &:last-child {
      flex: 0 0 ${theme.space.lg};
    }
  `}
`;

export const DescWrapper = styled(Flex)`
  width: 100%;
`;
